import { FetchArgs } from "@reduxjs/toolkit/query/react";
import { ParamsType } from "@/lib/interfaces";

export function getUrl(url: string, params?: any) {
  let urlFinal = url;
  if (params && Object.values(params).length > 0) {
    urlFinal = `${url}?data=${passGetQuery({ params })}`;
  }
  return urlFinal;
}

export function transformGetRequest(args: FetchArgs, method: string = "get") {
  const originalArgs =
    process.env.NODE_ENV === "development"
      ? {
          url: args.url,
          method,
        }
      : undefined;

  args.method = "post";
  args.body = {
    hash: encodeToHash({ url: args.url, method }),
    originalArgs,
  };
  args.url = `${window.location.origin}/api/app/get`;
}

export function transformPostRequest(args: FetchArgs, method: string = "post") {
  const originalArgs =
    process.env.NODE_ENV === "development"
      ? {
          url: args.url,
          method,
          body: args.body,
        }
      : undefined;

  args.body = {
    hash: encodeToHash({
      url: args.url,
      method,
      body: args.body,
    }),
    originalArgs,
  };
  args.url = `${window.location.origin}/api/app/post`;
}

// Add this function at the top of your file
export function encodeToHash(
  data: any,
  secret: string = process.env.NEXT_PUBLIC_API_SECRET || "default-secret"
): string {
  const jsonString = JSON.stringify(data);
  const combined = `${secret}:${jsonString}`;
  return btoa(combined); // Base64 encode
}

export function decodeFromHash(
  hash: string,
  secret: string = process.env.NEXT_PUBLIC_API_SECRET || "default-secret"
): any {
  const decoded = atob(hash); // Base64 decode

  const [extractedSecret, jsonString] = decoded.split(`${secret}:`);

  // if (extractedSecret !== secret) {
  //   throw new Error("Invalid hash");
  // }
  return JSON.parse(jsonString);
}

export const tagTypes = [
  "AppLink",
  "AppInternalState",
  "Asset",
  "AssetStatus",
  "AssetSub",
  "AssetGroup",
  "CategoryAsset",
  "CategoryAssetLevel2",
  "CategoryAssetLevel3",
  "CategoryAssetLevel4",
  "SfgServiceGroup",
  "Sfg",
  "CategoryAssetTag",
  "BillingUsage",
  "BoxDevice",
  "ControlRequest",
  "BoxDeviceStatus",
  "BoxInstance",
  "BoxDeviceUidRemap",
  "BoxMeter",
  "BoxDeviceMeter",
  "Building",
  "BuildingGroup",
  "BuildingLocation",
  "ContractBuilding",
  "UserBuildingRestriction",
  "BuildingApprovalGroup",
  "BuildingFloor",
  "BuildingThirdPartyApprovalUser",
  "BuildingZone",
  "Client",
  "ClientAssignment",
  "ClientRelationship",
  "ClientReverseRelationship",
  "ClientRelationshipBuilding",
  "AnalysisReportTemplate",
  "ClientRole",
  "UserClientRole",
  "ClientRolePrivilege",
  "BaseRole",
  "BaseRolePrivilege",
  "ColumnsOrder",
  "Competence",
  "Contract",
  "ContractConfig",
  "Currency",
  "Dashboard",
  "DeviceClass",
  "DeviceClassField",
  "DeviceClassIcon",
  "DeviceValueToLabelMap",
  "DeviceFieldValue",
  "EnergyConsumptionModel",
  "Floorplan",
  "HelpBlock",
  "ItemApproval",
  "JobPlan",
  "JobPlanSchedule",
  "JobPlanStatus",
  "Log",
  "WallDashboard",
  "Matterport",
  "BmsGifGlobal",
  "Message",
  "MessageThread",
  "MessageThreadUser",
  "MessageStatus",
  "MpTaskTemplate",
  "MpProjectTemplate",
  "Notification",
  "NotificationContent",
  "NotificationContentFooter",
  "NotificationClassification",
  "NotificationRecipient",
  "PasswordReset",
  "Permit",
  "DayPermit",
  "PermitHistory",
  "EmergencyPermit",
  "DayEmergencyPermit",
  "Privilege",
  "QRFreeLink",
  "RestRequestCache",
  "RestToken",
  "LoginEvent",
  "Sector",
  "Status",
  "SubmeterCategory",
  "Subsystem",
  "ContractSubsystem",
  "SystemDefaults",
  "AssetTask",
  "TaskCalendarGroup",
  "User",
  "UserLocationReport",
  "Zone",
  "AsbestosEntry",
  "AsbestosPhoto",
  "AsbestosAttachment",
  "AsbestosDrawing",
  "AsbestosQuoteLink",
  "AsbestosViewing",
  "AsbestosForm",
  "AsbestosStatus",
  "AsbestosPresence",
  "AsbestosSampleType",
  "AsbestosSurveyType",
  "AsbestosEntryRecommendation",
  "AsbestosActionTime",
  "AsbestosRiskBand",
  "AsbestosAssessor",
  "AsbestosYear",
  "AuditCategory",
  "AuditItem",
  "AuditReviewItem",
  "AuditSheet",
  "AuthUser",
  "AvailabilityAsset",
  "AvailabilityCategory",
  "AvailabilityHistory",
  "AvailabilityResource",
  "BmsGif",
  "BmsNetwork",
  "BmsCategory",
  "Alarm",
  "AlarmStatus",
  "AlarmCategory",
  "AlarmSchedule",
  "AnalysisReport",
  "AnalysisReportCredential",
  "Comment",
  "CriticalAlarmExecutionRecord",
  "CriticalAlarmExecutionPlan",
  "CriticalAlarmEngineResult",
  "DayMetrics",
  "DemandPeriodBreakdown",
  "EnergySummaryCache",
  "IOTInstance",
  "ItemStatusChangeRequest",
  "MachineProtection",
  "ManualInputInstance",
  "MeteredUtility",
  "TariffStart",
  "UtilityTariff",
  "UtilityUsage",
  "UtilityTimeBreakdown",
  "UtilityTimeBreakdownOverride",
  "RepeatingExport",
  "ScheduledControlEvent",
  "SensorResultCache",
  "DeviceClassCountMapCache",
  "VideoFeed",
  "CacheableFunction",
  "CachedResult",
  "CachedSeenParameter",
  "CallRecord",
  "ReportDatapoint",
  "BuildingDataValue",
  "TaskTemplate",
  "WorkOrder",
  "WorkType",
  "WorkStatus",
  "WorkCategory",
  "WorkOrderPriority",
  "WorkOrderEvent",
  "Attachment",
  "ComplianceAsset",
  "ComplianceVisit",
  "ComplianceVisitSheet",
  "Compliment",
  "ComplimentDepartment",
  "ContractcomplianceDocument",
  "ContractcomplianceFile",
  "ContractcomplianceNote",
  "ContractcomplianceRequirement",
  "ContractcomplianceType",
  "Dailyengineering",
  "DailyengineeringEntry",
  "DailyengineeringFile",
  "DlogsDoc",
  "DlogsCategory",
  "DlogItem",
  "DlogItemVisit",
  "DlogsNotifiedEmail",
  "Document",
  "DocumentCategory",
  "DocumentFolder",
  "DocumentsVote",
  "Company",
  "PermitsAuthorityToAcces",
  "PermitsAuthorityToAccesHistory",
  "PermitsControlMeasure",
  "PermitsRam",
  "PermitsRamNote",
  "PermitsRamsDictionaryService",
  "PermitsReissued",
  "PermitsReport",
  "PermitsSetting",
  "PermitsTemplate",
  "PermitsThirdPartyApprovalQueue",
  "LogBookCategory",
  "LogBookClientCategory",
  "LogBookTask",
  "LogBookClientTask",
  "LogBookLog",
  "LogBookVisit",
  "Failure",
  "DocumentsFinance",
  "Hazard",
  "HazardPhoto",
  "HazardCategory",
  "HazardType",
  "HazardCause",
  "HazardsEventsHistory",
  "HazardsEventsNote",
  "HnsAudit",
  "HnsFile",
  "HnsItem",
  "HnsProject",
  "InductionCategory",
  "InductionHistory",
  "InductionInvitation",
  "inductionPending",
  "InductionQuestion",
  "InductionTake",
  "Category",
  "DocumentsIntranet",
  "DocumentsIntranetVote",
  "KpiArea",
  "KpiAttachment",
  "KpiItem",
  "KpiSheet",
  "KpiTemplate",
  "KpiToleranceBand",
  "KpiServiceLevel",
  "LifecycleAsset",
  "LifecycleCategory",
  "LifecycleItem",
  "MailingMessage",
  "MobileauditAudit",
  "MobileauditFile",
  "MobileauditItem",
  "MobileauditProject",
  "MpTask",
  "MpProject",
  "MpTaskProgress",
  "PpmimportQueue",
  "Quote",
  "QuoteUser",
  "Visit",
  "VisitParent",
  "VisitSheet",
  "Labour",
  "Material",
  "QuotesAttachment",
  "QuotesContractor",
  "QuotesHistory",
  "QuotesLabour",
  "QuotesMaterial",
  "QuotesRequest",
  "Risk",
  "RiskAttachment",
  "RiskCategory",
  "RiskHistory",
  "RiskNote",
  "RiskVote",
  "RotaAsset",
  "RotaShift",
  "RotaVisit",
  "Shiftlog",
  "ShiftlogEntry",
  "ShiftlogFile",
  "SOPDocument",
  "SOPDocumentState",
  "SOPRole",
  "SOPTemplate",
  "SOPPriority",
  "SOPProcedureType",
  "SOPProcedureStatus",
  "SOPCategory",
  "SOPStatus",
  "SOPNotification",
  "DocumentsTechlib",
  "DocumentsTechlibVote",
  "Ticket",
  "Induction",
  "TmHistory",
  "TmPersonnel",
  "TmPersonnelBuilding",
  "TmPersonnelFile",
  "TmPosition",
  "TmPositionProgramme",
  "TmProgramme",
  "TmProgrammeBuilding",
  "TmProgrammeCategory",
  "TmProgrammeSubCategory",
  "TmSuppressed",
  "Translation",
  "UserCertificate",
  "WalkaroundAsset",
  "WalkaroundCategory",
  "WalkaroundCode",
  "WalkaroundField",
  "WalkaroundFieldCondition",
  "WalkaroundShift",
  "WarrantyDocument",
  "WarrantyDocumentEvent",
  "WarrantyCategory",
  "DocumentsWarrantyVote",
  "AssetPlacement",
  "Drawing",
  "Clients",
  "Dashboards",
  "Users",
  "Risks",
  "Buildings",
  "Contracts",
  "Assets",
  "Visit",
  "VisitSheet",
  "Generic",
  "Rera",
];

export function passGetQuery({ params }: ParamsType) {
  const queryStrings: any = {};
  Object.keys(params).map((arg, _index) => {
    queryStrings[arg] = params[arg];
  });
  return encodeURIComponent(JSON.stringify(queryStrings));
}
